// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"b6f2225f","341":"3f70ea31","420":"30646f6b","714":"e6e0aa1d"}[chunkId] + ".chunk.css";
};